import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { checkmark } from '@purpur/library/icon/assets/checkmark';
import { minus } from '@purpur/library/icon/assets/minus';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

type Props = {
    featureValue: string;
};

export const CharacteristicsFeatureValue: FC<Props> = ({ featureValue }) => {
    const { t } = useTranslations();

    if (featureValue.startsWith('http')) {
        return (
            <a href={featureValue} target="_blank" rel="noreferrer">
                {featureValue}
            </a>
        );
    }
    const lowerCaseValue = featureValue?.trim()?.toLowerCase();
    if (lowerCaseValue === 'true' || lowerCaseValue === 'taip') {
        return (
            <span role="img" aria-label={t['eshop.product_page.feature.checkmark_alt']}>
                <Icon svg={checkmark} size="sm" aria-hidden="true" />
            </span>
        );
    } else if (lowerCaseValue === 'false' || lowerCaseValue === 'ne' || lowerCaseValue === '-') {
        return (
            <span role="img" aria-label={t['eshop.product_page.feature.minus_alt']}>
                <Icon svg={minus} size="sm" aria-hidden="true" />
            </span>
        );
    } else {
        return <>{featureValue}</>;
    }
};
